/**
 * Monitoring + GA4 analytics
 * LogRocket disabled — was causing "Response body already used" errors
 * across fetch calls (voice messages, file uploads, etc.)
 *
 * trackEvent forwards to GA4 via gtag. gtag is loaded on page load in index.html and
 * self-disables (`ga-disable-*`) for visitors who opt out, so these calls become no-ops
 * automatically — no consent checks needed here.
 */

export const initMonitoring = async () => {};
export const identifyUser = () => {};
export const clearUserIdentity = () => {};
export const captureError = () => {};
export const setTag = () => {};

const SIGNUP_WINDOW_MS = 2 * 60 * 1000;

export const trackEvent = (name, params = {}) => {
  if (!name || typeof window === 'undefined') return;
  if (window.location.pathname.startsWith('/ti-admin')) return;
  try {
    window.gtag?.('event', name, params);
  } catch (e) { /* analytics must never break the app */ }
};

/** sign_up for brand-new accounts, login otherwise (decided from how fresh the account is). */
export const trackAuth = (user, method = 'oauth') => {
  if (!user) return;
  const created = Date.parse(user.created_at || user.member_since || '');
  const isNew = Number.isFinite(created) && (Date.now() - created) < SIGNUP_WINDOW_MS;
  trackEvent(isNew ? 'sign_up' : 'login', {
    method,
    role: user.role_preference || user.role || 'unknown',
  });
};

export default {
  initMonitoring,
  identifyUser,
  clearUserIdentity,
  trackEvent,
  trackAuth,
  captureError,
  setTag,
};
